import { render } from "./BackdropFilter.vue?vue&type=template&id=036d9ca4&scoped=true&ts=true"
import script from "./BackdropFilter.vue?vue&type=script&lang=ts"
export * from "./BackdropFilter.vue?vue&type=script&lang=ts"

import "./BackdropFilter.vue?vue&type=style&index=0&id=036d9ca4&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036d9ca4"]])

export default __exports__